export class TargetPromotor {
    public EmpleadoId ?:string;
    public FechaVenta?:string;
    public Colocacion?:number;  
    public Comision?:number;  
    public AjusteComision?:number;
    public ComisionFinal?:number;
    public Comentario?:string;

  }
  